import React from "react";
import "./bottombar.scss";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { getHasOutlets } from "../../../store/outlet/selectors";
import Routes from "../../../routes";
import useContent from "../../../hooks/useContent";
import BottombarNavigationButton from "./BottombarNavigationButton";

export const Bottombar: React.FC = props => {
  const { managerAppSidebar: content } = useContent();
  const noOutlets = !useSelector(getHasOutlets);

  return (
    <div className={classnames("bottombar")} {...props}>
      <BottombarNavigationButton
        to={noOutlets ? Routes.empty : Routes.overviewAll}
        icon="home"
        title={content.manager_app_overview}
      />
      <BottombarNavigationButton
        to={Routes.sales}
        icon="sales"
        title={content.manager_app_sales}
        disabled={noOutlets}
      />
      <BottombarNavigationButton
        to={Routes.product}
        icon="keg"
        title={content.manager_app_product}
        disabled={noOutlets}
      />
      <BottombarNavigationButton
        to={Routes.installation}
        icon="installation"
        title={content.manager_app_installation}
      />
      <BottombarNavigationButton
        to={Routes.settings}
        icon="settings"
        title={content.manager_app_settings}
      />
    </div>
  );
};
export default Bottombar;
